import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import client from '../api/client';

export default function GlobalSearch({ open, onClose }) {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [results, setResults] = useState(null);
  const inputRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    if (open) setTimeout(() => inputRef.current?.focus(), 50);
    else { setQ(''); setResults(null); }
  }, [open]);

  useEffect(() => {
    clearTimeout(timerRef.current);
    if (q.trim().length < 2) { setResults(null); return; }
    timerRef.current = setTimeout(() => {
      client.get('/search', { params: { q } }).then(r => setResults(r.data)).catch(() => {});
    }, 250);
    return () => clearTimeout(timerRef.current);
  }, [q]);

  const go = (path) => { onClose(); navigate(path); };

  if (!open) return null;

  const hasResults = results && (results.participants.length || results.events.length || results.disciplines.length || results.organizations.length);

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,22,38,0.55)', zIndex: 100, display: 'flex', justifyContent: 'center', paddingTop: '10vh' }} onClick={onClose}>
      <div className="card" style={{ width: 560, maxWidth: '92vw', maxHeight: '70vh', overflow: 'auto', padding: 0 }} onClick={e => e.stopPropagation()}>
        <div style={{ padding: 14, borderBottom: '1px solid var(--line)' }}>
          <input
            ref={inputRef}
            value={q}
            onChange={e => setQ(e.target.value)}
            placeholder="ابحث عن مشارك، فعالية، مسابقة، أو جهة..."
            style={{ width: '100%', border: 'none', outline: 'none', fontSize: 16, fontFamily: 'var(--font-body)' }}
          />
        </div>

        <div style={{ padding: q.length >= 2 ? '6px 0' : 0 }}>
          {q.length < 2 && <div style={{ padding: 20, textAlign: 'center', color: 'var(--muted)', fontSize: 13 }}>اكتب حرفين على الأقل للبحث</div>}

          {results?.participants?.length > 0 && (
            <div>
              <div style={{ padding: '6px 14px', fontSize: 11, color: 'var(--muted)', textTransform: 'uppercase' }}>المشاركون</div>
              {results.participants.map(p => (
                <div key={p.id} style={{ padding: '8px 14px', cursor: 'pointer', display: 'flex', gap: 8, alignItems: 'center' }} onClick={() => go(`/participants/${p.id}`)}>
                  <span className="badge" style={{ background: p.color_code }}>{p.category_name_ar}</span>
                  <span>{p.full_name_ar}</span>
                </div>
              ))}
            </div>
          )}
          {results?.events?.length > 0 && (
            <div>
              <div style={{ padding: '6px 14px', fontSize: 11, color: 'var(--muted)', textTransform: 'uppercase' }}>الفعاليات</div>
              {results.events.map(e => (
                <div key={e.id} style={{ padding: '8px 14px', cursor: 'pointer' }} onClick={() => go(`/events/${e.id}`)}>{e.name_ar}</div>
              ))}
            </div>
          )}
          {results?.disciplines?.length > 0 && (
            <div>
              <div style={{ padding: '6px 14px', fontSize: 11, color: 'var(--muted)', textTransform: 'uppercase' }}>مسابقات الرماية</div>
              {results.disciplines.map(d => (
                <div key={d.id} style={{ padding: '8px 14px', cursor: 'pointer' }} onClick={() => go(`/results/${d.id}`)}>{d.name_ar}</div>
              ))}
            </div>
          )}
          {results?.organizations?.length > 0 && (
            <div>
              <div style={{ padding: '6px 14px', fontSize: 11, color: 'var(--muted)', textTransform: 'uppercase' }}>الجهات والاتحادات</div>
              {results.organizations.map(o => (
                <div key={o.id} style={{ padding: '8px 14px', cursor: 'pointer' }} onClick={() => go('/organizations')}>{o.name_ar}</div>
              ))}
            </div>
          )}
          {results && !hasResults && <div style={{ padding: 20, textAlign: 'center', color: 'var(--muted)', fontSize: 13 }}>لا توجد نتائج</div>}
        </div>
      </div>
    </div>
  );
}
